var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-page',{attrs:{"name":"User","use":"_id","display":_vm.display,"page-prefix":"/blade/users","fetch":_vm.getUsers,"remove":_vm.deleteUser,"sort-options":_vm.sortOptions,"sort-functions":_vm.sortFunctions,"default-sort":_vm.defaultSort}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5414e44c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/UsersList.vue
// module id = null
// module chunks = 